import * as types from "./types";

const initialState = {
  list: [],
  meta: {
    currentPage: 1,
    count: 0,
    pages: 1,
  },
  creating: false,
  current: null,
  loading: false,
  updating: false,
  deleting: false,
};

const companyRoles = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_ROLES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case types.CREATE_COMPANY_ROLE_REQUEST:
      return { ...state, creating: true };
    case types.CREATE_COMPANY_ROLE_SUCCESS:
    case types.CREATE_COMPANY_ROLE_FAILURE:
      return { ...state, creating: false };
    case types.GET_COMPANY_ROLE_REQUEST:
      return { ...state, loading: true };
    case types.GET_COMPANY_ROLE_RESPONSE:
      return { ...state, loading: false, current: action.payload };
    case types.CLEAR_COMPANY_ROLE:
      return { ...state, current: null };
    case types.UPDATE_COMPANY_ROLE_REQUEST:
      return { ...state, updating: true };
    case types.UPDATE_COMPANY_ROLE_SUCCESS:
      return { ...state, updating: false, current: action.payload };
    case types.UPDATE_COMPANY_ROLE_FAILURE:
      return { ...state, updating: false };
    case types.DELETE_COMPANY_ROLE_REQUEST:
      return { ...state, deleting: true };
    case types.DELETE_COMPANY_ROLE_SUCCESS:
    case types.DELETE_COMPANY_ROLE_FAILURE:
      return { ...state, deleting: false };
    default:
      return state;
  }
};

export default companyRoles;
